<template>
    <form
        class="settings-edit"
        @submit.prevent=""
        @keydown.enter.prevent = ""
    >
        <model-icon
            :url.sync="localNluModel.imageSrc"
            :default-image="defaultImage"
            editable
        />
        <slot name="culture" />

        <or-textbox
            v-model="$v.localNluModel.name.$model"
            :label="$t('model.nlu-model.settings.settings-edit.name')"
            :placeholder="$t('model.nlu-model.settings.settings-edit.nluModelName')"
            enforceMaxlength
            :invalid="!!errors.name"
            :error="errors.name"
            :maxlength="sizeLimits.title.max"
        />

        <or-textbox
            v-model="localNluModel.desc"
            :label="$t('model.nlu-model.settings.settings-edit.description')"
            :placeholder="$t('model.nlu-model.settings.settings-edit.nluModelDescription')"
            enforceMaxlength
            :maxlength="sizeLimits.description.max"
        />

        <div class="actions">
            <delete-model-btn
                :modal-title="$t('model.nlu-model.settings.settings-edit.deleteNluModel')"
                :is-deleting="isDeleting || isEditing"
                @delete="deleteModel"
            />
            <div>
                <or-button
                    class="cancel-button"
                    color="primary"
                    type="secondary"
                    buttonType="button"
                    :loading="isEditing"
                    @click="cancelEditing"
                >
                  {{ $t('generic.cancel') }}
                </or-button>
                <or-button
                    color="primary"
                    buttonType="submit"
                    :loading="isEditing"
                    @click="updateModel"
                >
                  {{ $t('generic.update') }}
                </or-button>
            </div>
        </div>
    </form>
</template>

<script>
import { meta_limits as metaLimits } from '@/modules/limits'
import { nluModelSettingsValidation } from '@/mixins/models-validation.mixin'

import ModelIcon from '../../common/model_icon'
import DeleteModelBtn from '../../common/delete-model-button'

export default {
  components: {
    ModelIcon,
    DeleteModelBtn
  },

  mixins: [nluModelSettingsValidation],

  data () {
    return {
      localNluModel: _.cloneDeep(this.$props.nluModel),
      defaultCoverUrl: 'https://qa-filesanddata-asset-manager-xux8mqnqka.s3-us-west-2.amazonaws.com/6ceadd6c-dbe3-4cb6-8643-889e8d339c77/nlu-ui/kb-default.png'
    }
  },

  props: {
    nluModel: {
      type: Object,
      default: () => ({})
    },

    defaultImage: String,
    isEditing: Boolean,
    isDeleting: Boolean
  },

  computed: {
    sizeLimits () {
      return metaLimits
    }
  },

  methods: {
    updateModel () {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      this.$emit('edit', this.localNluModel)
    },

    cancelEditing () {
      this.$emit('cancel')
    },

    deleteModel () {
      this.$emit('delete')
    }
  },

  watch: {
    nluModel: {
      handler (newNluModel) {
        this.localNluModel = _.cloneDeep(newNluModel)
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
    .actions {
        display: flex;
        justify-content: space-between;
        margin-top: $sp-5;
        .cancel-button {
            margin-right: $sp-3;
        }
    }
</style>
